var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"column",staticClass:"column"},_vm._l((_vm.dataArray),function(item,index){return _c('button',{key:index,staticClass:"column-item",class:{
      'column-item-selected': _vm.selectedItem === item,
    },on:{"click":function($event){return _vm.onItemClick(item)}}},[_vm._v(" "+_vm._s(_vm._f("timeValue")(item))+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }